import styled from '@emotion/styled';
import { Indicator2Values, Model } from '@gameonly/core';

import { useTranslation } from 'react-i18next';
import keyify from '../project/parameters/keyify';
import { TitleScoreContainer } from './ResultsSimple';

import { ReactElement } from 'react';
import { ReactComponent as Energy } from '../ui/icons/results/Énergie impact.svg';
import { ReactComponent as Water } from '../ui/icons/results/Eau.svg';
import { ReactComponent as Ressources } from '../ui/icons/results/Ressources abiotiques-11.svg';
import { ReactComponent as GES } from '../ui/icons/results/GES.svg';

const IndicatorComponentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const IconContainer = styled.div`
  height: 50px;
  width: 50px;
`;

const IndicatorsTable = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid var(--grey);
  overflow: hidden;
  margin-left: auto;
`;

const IndicatorCell = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  padding: 6px;
  background-color: 'white';
  border-right: 1px solid var(--grey);

  &:last-of-type {
    border-right: none;
  }

  b {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.25;
    color: var(--grey);
  }

  span {
    font-size: 10px;
    font-weight: 400;
    line-height: 1.25;
    font-weight: 600;
    color: var(--grey);
  }
`;

const IconMapping: { [key: string]: ReactElement } = {
  co2: <GES />,
  energie: <Energy />,
  eau: <Water />,
  ressources: <Ressources />,
};

interface Indicator2ValuesProps {
  result: Indicator2Values;
  model: Model;
}

const Indicator2ValuesComponent = ({
  result,
  model,
}: Indicator2ValuesProps) => {
  const { t } = useTranslation(['project', 'model']);
  const number1 =
    Number(
      typeof result.displayed_number1 !== 'undefined'
        ? result.displayed_number1
        : result.number1,
    ) || 0;
  const number2 =
    Number(
      typeof result.displayed_number2 !== 'undefined'
        ? result.displayed_number2
        : result.number2,
    ) || 0;
  const translationPrefix = `model:${keyify(
    model.name,
  )}.result.${result.code?.toLowerCase()}`;
  const icon =
    result.code !== undefined
      ? IconMapping[result.code] || undefined
      : undefined;
  return (
    <IndicatorComponentContainer>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <IconContainer>{icon}</IconContainer>
        <TitleScoreContainer>
          <p>{t(`${translationPrefix}.title`)}</p>
        </TitleScoreContainer>
      </div>
      <IndicatorsTable>
        <IndicatorCell>
          <b>{number1}</b>
          <span>
            {t(`${translationPrefix}.displayed_unit1`) ||
              t(`${translationPrefix}.unit1`) ||
              ''}
          </span>
        </IndicatorCell>
        <IndicatorCell>
          <b>{number2}</b>
          <span>
            {t(`${translationPrefix}.displayed_unit2`) ||
              t(`${translationPrefix}.unit2`) ||
              ''}
          </span>
        </IndicatorCell>
      </IndicatorsTable>
    </IndicatorComponentContainer>
  );
};

export default Indicator2ValuesComponent;
